import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

const apiUrlSheets = "/sheets";

export type SheetDataLdsApiRow = {
  row_id: string;
  sheet_data_cells: {
    [key: string]: string;
  };
};

export const parseSheetDataLdsApiRow = ({
  row_id,
  sheet_data_cells,
}: SheetDataLdsApiRow) => ({
  id: row_id,
  value: sheet_data_cells,
});

export const getAllRows = async ({
  organizationId,
  versionId,
  sheetId,
}: {
  organizationId: string;
  versionId: string;
  sheetId: string;
}) => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.get<{ items: SheetDataLdsApiRow[] }>(
    `${apiUrlSheets}/${sheetId}/rows`,
    {
      params: {
        org_id: organizationId,
        version: versionId,
      },
      ...apiHeadersWithJson,
    }
  );
  return response.data.items;
};

export const postInsertRows = async ({
  organizationId,
  versionId,
  sheetId,
  items,
  afterRowId,
}: {
  organizationId: string;
  versionId: string;
  sheetId: string;
  items: SheetDataLdsApiRow[];
  afterRowId?: string | null;
}) => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.post<void>(
    `${apiUrlSheets}/${sheetId}/rows`,
    {
      items,
      after_row_id: afterRowId,
    },
    {
      params: {
        org_id: organizationId,
        version: versionId,
      },
      ...apiHeadersWithJson,
    }
  );
  return response.data;
};

export const postUpdateRows = async ({
  organizationId,
  versionId,
  sheetId,
  items,
}: {
  organizationId: string;
  versionId: string;
  sheetId: string;
  items: SheetDataLdsApiRow[];
}) => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.post<void>(
    `${apiUrlSheets}/${sheetId}/rows/update`,
    {
      items,
    },
    {
      params: {
        org_id: organizationId,
        version: versionId,
      },
      ...apiHeadersWithJson,
    }
  );
  return response.data;
};

export const postMoveRows = async ({
  organizationId,
  versionId,
  sheetId,
  rowIds,
  afterRowId,
}: {
  organizationId: string;
  versionId: string;
  sheetId: string;
  rowIds: string[];
  afterRowId?: string;
}) => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.post<void>(
    `${apiUrlSheets}/${sheetId}/rows/move`,
    {
      row_ids: rowIds,
      after_row_id: afterRowId,
    },
    {
      params: {
        org_id: organizationId,
        version: versionId,
      },
      ...apiHeadersWithJson,
    }
  );
  return response.data;
};

export const postDeleteAllRows = async ({
  organizationId,
  versionId,
  sheetId,
}: {
  organizationId: string;
  versionId: string;
  sheetId: string;
}) => {
  const { apiHeadersWithJson } = getAPIConfigs();
  await API_CLIENT.post<void>(
    `${apiUrlSheets}/${sheetId}/delete_rows`,
    {},
    {
      params: {
        org_id: organizationId,
        version: versionId,
      },
      ...apiHeadersWithJson,
    }
  );
};
